<!--suppress UnnecessaryLabelJS -->
<template>
	<v-data-table
		:headers="headers"
		:items="types"
		:loading="loading"
		class="elevation-1"
		:mobile-breakpoint="NaN"
	>
		<v-progress-linear
			slot="progress"
			color="blue"
			indeterminate
		/>
		<template #item="{item}">
			<type-row
				:key="item.id"
				:type="item"
				@edit="onEdit"
			/>
		</template>
	</v-data-table>
</template>

<script>
import TypeRow from "src/view/types/TypeRow";
import { types } from "src/store/modules/Type.module";
import FilterAble from "src/mixins/FilterAble";

export default {
	name: "TypesTable",
	components: {
		TypeRow,
	},
	props: [],
	mixins: [new FilterAble(types)],
	data () {
		return {
			loading: false,
			headers: [
				{ text: "name", value: "name" },
        {text: "קטגוריה וקושי", value: "category_and_difficulty"},
        {text: "תשובה נכונה בלבד", value: "is_default_only_one_true_answer"},
        { text: "שם קובץ", value: "json_path" },

			],
			search: null,
			showDialog: false,
		};
	},
	computed: {
		types () {
			return this.$store.state.TypeModule.types;
		},
	},
	methods: {
		onEdit (Type) {
			this.$emit("edit", Type);
		},
	},
};
</script>

<style>

</style>
